import { render, staticRenderFns } from "./syntunys.vue?vue&type=template&id=cef88bac&scoped=true&"
import script from "./syntunys.vue?vue&type=script&lang=js&"
export * from "./syntunys.vue?vue&type=script&lang=js&"
import style0 from "./syntunys.vue?vue&type=style&index=0&id=cef88bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef88bac",
  null
  
)

export default component.exports